import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import {
  IAddProcessTemplate,
  IUpdateProcessTemplate,
} from '../../../models/forms/IAddUpdateProcessTemplate';
import { IFormModalProps } from '../../../models/forms/IForm';
import { formatMessage } from '../../../translations/format-message';
import AddEditProcessTemplateForm from '../forms/add-edit-process-template-form';

const AddEditProcessTemplate = (props: IFormModalProps) => {
  const { processTemplateStore, processStore } = useStore();
  const {
    AddProcessTemplateService,
    UpdateProcessTemplateService,
    GetProcessTemplateByIdService,
    resetAddUpdateProcessTemplateState,
    resetProcessTemplateDetail,
    addUpdateProcessTemplateState,
    processTemplateDetails,
  } = processTemplateStore;

  const { allProcess, allProcessReactSelectOptions, GetAllProcessService } =
    processStore;
  const initialValues: IAddProcessTemplate | IUpdateProcessTemplate =
    processTemplateDetails;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (props.id > 0) {
      GetProcessTemplateByIdService(
        Number(getTenantIdFromLocalStorage()),
        props.id
      );
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateProcessTemplateState.success) {
      if (props.id === -1) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [addUpdateProcessTemplateState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateProcessTemplateState.error) {
      toast.error(formatMessage(addUpdateProcessTemplateState.error));
      resetAddUpdateProcessTemplateState();
    }
  }, [addUpdateProcessTemplateState.error]);

  useEffect(() => {
    GetAllProcessService();
  }, []);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = ({
    TemplateName,
    Remarks,
    ProcesTemplates,
    TenantId,
    Type,
    ShortName,
  }: IAddProcessTemplate) => {
    var addObj: IAddProcessTemplate = {
      TemplateName,
      Remarks,
      TenantId,
      ProcesTemplates,
      ShortName: ShortName,
    };

    var updateObj: IUpdateProcessTemplate = {
      Id: props.id,
      TemplateName,
      Remarks,
      ProcesTemplates,
      TenantId,
    };

    if (props.id < 0) {
      AddProcessTemplateService(addObj);
    } else {
      UpdateProcessTemplateService(updateObj);
    }
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetProcessTemplateDetail();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <AddEditProcessTemplateForm
        initialValues={initialValues}
        id={props.id}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={addUpdateProcessTemplateState.inProgress}
        allProcess={allProcess}
        allProcessesOptions={allProcessReactSelectOptions}
      />
    </React.Fragment>
  );
};

export default observer(AddEditProcessTemplate);
